import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface DocumentComplianceResult {
  missingESign: string[];
  missingPostHire: string[];
  loading: boolean;
  error?: string;
}

export const useDocumentCompliance = (
  username?: string,
  enabled: boolean = true
): DocumentComplianceResult => {
  const client = useMyProviderDataClient();

  const [missingESign, setMissingESign] = useState<string[]>([]);
  const [missingPostHire, setMissingPostHire] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled || !username) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const [eSignRes, postHireRes] = await Promise.all([
          client.get("/EmployeeInformation/MissingESignDocuments", { params: { username } }),
          client.get("/EmployeeInformation/MissingPostHireDocuments", { params: { username } }),
        ]);

        setMissingESign(
          Array.isArray(eSignRes.data)
            ? eSignRes.data.map((d: any) => d.title ?? "")
            : []
        );
        setMissingPostHire(
          Array.isArray(postHireRes.data)
            ? postHireRes.data.map((d: any) => d.title ?? "")
            : []
        );
      } catch (err) {
        console.error(err);
        setError("Failed to load document compliance data.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, enabled, client]);

  return { missingESign, missingPostHire, loading, error };
};
